<template>
    <div class="com-banner">
        <div class="com-banner-wrapper container">
            <div class="com-banner__items">
                <div class="com-banner__item">
                    <b class="com-banner__item-text">有寄，回国物流系统合作商</b>
                    专注回国物流一站式解决方案<br>
                    <a class="com-banner__item-action" href="javascript:;" @click="scollTop('contact')">联系我们</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-banner',
    methods: {
        scollTop(name) {
            this.$emit('scroll', name)
        }
    }
}
</script>

<style lang="less" scoped>
    .com-banner {
        background: -webkit-linear-gradient(left,#40bc66,#7cc54f);
        padding-bottom: .4rem;
        padding-top: .8rem;
        &__items {
            background: url('~@/assets/map.png') no-repeat right center;
            background-size: 7.5rem;
            height: 5rem;
            color: #fff;
            font-size: .3rem;
            padding-top: 0.5rem;
        }
        &__item {
            &-text {
                display: block;
                color: #fff;
                font-weight: bold;
                width: 100%;
                font-size: .55rem;
                margin: .9rem 0 .15rem;
            }
            &-action {
                display: inline-block;
                border: .03rem solid #fff;
                padding: .2rem .5rem 0.15rem;
                border-radius: .5rem;
                margin-top: .35rem;
                font-size: .3rem;
                color: #fff;
            }
        }
    }

    @media only screen and (max-width: 800px) {
        .com-banner {
            background: #40bc66;
            &__items {
                text-align: center;
                font-size: .4rem;
                background-position: center 3.7rem;
                padding: .5rem 0 2rem 0;
            }
            &__item {
                &-text {
                    margin: .2rem 0;
                    font-weight: normal;
                    font-size: .65rem;
                }
                &-action {
                    background: #fff;
                    color: #40bc66;
                    font-size: .37rem;
                }
            }
        } 
    }
</style>

